'use client';

import { useEffect } from 'react';

export function ProfileViewTracker({ mentorId }: { mentorId: string }) {
  useEffect(() => {
    const t = setTimeout(() => {
      fetch('/api/track/profile-view', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mentorId }),
      })
        .then(res => {
          if (!res.ok) {
            console.error('Profile view tracking failed:', res.status);
          }
        })
        .catch(err => {
          console.error('Profile view tracking error:', err);
        });
    }, 5_000);
    return () => clearTimeout(t);
  }, [mentorId]);

  return null;
}
